import { Bug, ClipboardList, FlaskConical, Flag, KanbanSquare, Rocket, ShieldCheck, Star, Truck, Users, Wrench, Zap, type LucideIcon } from 'lucide-react'
import { boardTint, isBoardIcon, type BoardIconKey } from '@/lib/boardLook'
import { cn } from '@/lib/utils'

export const BOARD_ICONS: Record<BoardIconKey, LucideIcon> = {
  kanban: KanbanSquare,
  rocket: Rocket,
  flask: FlaskConical,
  shield: ShieldCheck,
  bug: Bug,
  clipboard: ClipboardList,
  wrench: Wrench,
  truck: Truck,
  users: Users,
  star: Star,
  flag: Flag,
  zap: Zap,
}

/** A board's icon in its colour; the kanban icon in primary when it has neither. */
export function BoardIcon({ icon, color, className }: { icon?: string | null; color?: string | null; className?: string }) {
  const Icon = isBoardIcon(icon) ? BOARD_ICONS[icon] : KanbanSquare
  return <Icon className={cn('size-4 shrink-0', boardTint(color), className)} aria-hidden />
}
